export function convertSpacesToNonBreakingSpaces(s: string) {
  return s.split(" ").join("\u00A0");
}

// http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-
export function hash(s: string) {
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    /* eslint-disable no-bitwise */
    hash = s.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
    /* eslint-enable no-bitwise */
  }
  return hash;
}
